module.exports = __webpack_public_path__ + "media/images/wallet/payment1-1f2d57623f35628a7a13a4fa84b8acc8.svg";